<div class="sp-width__full sp-row__space sp-wrap">
  <div class="sp-row__align">
    <div
      class="sp-circle__xs sp-margin__right"
      [ngClass]="getCompanyStatusBackgroundClass(company)"></div>
    <span class="sp-color__primary"> {{ company?.business_name }} </span>
  </div>

  <div class="sp-row__align">
    <span class="sp-color__primary"> {{ company?.created_at | date : 'short' }} </span>
    <button
      (click)="onContractClick(company)"
      mat-icon-button
      [matTooltip]="'COMPANIES.CONTRACTS_VIEW_CTA' | translate">
      <mat-icon
        class="material-symbols-outlined"
        color="accent">
        description
      </mat-icon>
    </button>
  </div>
  <hr class="sp-width__full sp-stroke sp-stroke__dashed-dark" />
</div>
